<template>
    <div>
        <div class="b_head_banner">
            <div
                v-full-background-image-path:assets="'head_circles_decor.svg'"
                class="banner_image bg_image cover"
            />
            <div class="banner_wrapper flex">
                <div class="banner_wrapper_inner">
                    <div class="container">
                        <div class="banner_title second_font text_center">
                            שקיפות
                        </div>
                        <div class="search_form">
                            <div class="form_wrapper">
                                <form @submit.prevent="fetchTransparency">
                                    <div class="form_row">
                                        <input
                                            v-model="search"
                                            class="form_control"
                                            type="text"
                                            placeholder="חפש נציגים או בעלי תפקידים"
                                        />
                                        <button
                                            class="btn_serarch btn_reset"
                                            type="submit"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="b_transparency">
            <div class="container">
                <div class="page_title second_font">
                    שקיפות האגודה
                </div>
                <div class="single_content">
                    <p>
                        לנו באגודת הסטודנטים והסטודנטיות באוניברסיטה העברית (ע"ר
                        580003952) חשוב לשמור על שקיפות מלאה.
                        <br />
                        בעמוד זה תוכלו למצוא פרוטוקולים ותיעוד כתוב של כל
                        ההחלטות, הישיבות והדיונים, אישורי התקציב שנערכו והתקבלו
                        בשנים האחרונות.
                        <br />
                        בכל שאלה, דיווח על מסמך חסר או בעיית שקיפות כזו או אחרת
                        - נבקשכם
                        <a href="mailto:mancal@aguda.org.il" target="_blank">
                            לפנות אלינו בהקדם
                        </a>
                    </p>
                </div>
            </div>

            <type-selector @selected="onTypeSelected" />

            <div class="transparency_body">
                <div class="container">
                    <year-selector @selected="onYearSelected" />

                    <div class="data_wrapper">
                        <div
                            v-for="item in items"
                            :key="item.year"
                            class="data_row"
                        >
                            <div class="row_title second_font">
                                {{ item.year }}
                            </div>
                            <div class="data_list">
                                <single-item
                                    v-for="transparency in item.items"
                                    :key="transparency.id"
                                    :transparency="transparency"
                                />
                            </div>
                        </div>

                        <div
                            v-if="isMoreAvailable"
                            class="btn_wrapper text_center"
                        >
                            <button
                                class="btn btn_template"
                                type="button"
                                @click="fetchTransparency(true)"
                            >
                                טען עוד
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import SingleItem from '@/components/transparency/SingleItem';
import TypeSelector from '@/components/transparency/TypeSelector';
import YearSelector from '@/components/transparency/YearSelector';

export default {
    components: {
        SingleItem,
        TypeSelector,
        YearSelector
    },

    async asyncData({ store: { dispatch }, error, $dayjs }) {
        try {
            const params = {
                page: 1,
                perPage: 10
            };

            const { rows, count: total } = await dispatch(
                'transparency/index',
                params
            );

            const count = rows.length;
            const items = [];

            rows.forEach(item => {
                const year = $dayjs(item.meetingDate).format('YYYY');

                const index = items.findIndex(
                    yearItems => yearItems.year === year
                );

                if (~index) {
                    items[index].items.push(item);
                } else {
                    items.push({ year, items: [item] });
                }
            });

            return { items, params, count, total };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    data() {
        return {
            search: '',
            type: null,
            year: null
        };
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        }),

        isMoreAvailable() {
            return this.count < this.total;
        }
    },

    watch: {
        search() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.timer = setTimeout(() => {
                this.fetchTransparency();
            }, 500);
        },

        selectedCampus() {
            this.resetTransparency();
        }
    },

    methods: {
        ...mapActions({
            getTransparency: 'transparency/index'
        }),

        onTypeSelected(type) {
            this.type = type;

            this.fetchTransparency();
        },

        onYearSelected(year) {
            this.year = year;

            this.fetchTransparency();
        },

        async fetchTransparency(getMore = false) {
            try {
                this.params.page = getMore ? this.params.page + 1 : 1;

                const { rows, count } = await this.getTransparency({
                    ...this.params,
                    search: this.search,
                    type: this.type,
                    year: this.year
                });

                this.total = count;
                this.count = getMore ? this.count + rows.length : rows.length;

                if (!getMore) {
                    this.items = [];
                }

                rows.forEach(item => {
                    const year = this.$dayjs(item.meetingDate).format('YYYY');

                    const index = this.items.findIndex(
                        yearItems => yearItems.year === year
                    );

                    if (~index) {
                        this.items[index].items.push(item);
                    } else {
                        this.items.push({ year, items: [item] });
                    }
                });
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        },

        resetTransparency() {
            this.params.page = 1;
            this.fetchTransparency();
        }
    }
};
</script>
